import styled from "styled-components";

export const Wrapper = styled.div`
.bdr{border:1px solid red !important;}

.billing-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0px 18px;
  }

  .billing-title {
    font-size: 22px;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.02em;
  }

  .billing-subtitle {
    margin-top: 4px;
    font-size: 13px;
    color: #6b7280;
  }

  .billing-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(6px);
    border: 1px solid rgba(229, 231, 235, 0.9);
    box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06);
    white-space: nowrap;
  }
  .billing-status__icon {
    color: #22c55e;
    font-size: 16px;
  }
  .billing-status__text {
    color: #374151;
    font-size: 13px;
  }
  .billing-status__dot {
    opacity: 0.6;
    margin: 0 6px;
  }

  .billing-card {
    border-radius: 14px;
    overflow: hidden;
  }

  .billing-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .billing-section-title {
    font-size: 17px;
    font-weight: 800;
    color: #111827;
  }
  .billing-section-subtitle {
    margin-top: 2px;
    font-size: 13px;
    color: #6b7280;
  }

  .billing-btn {
    // border-radius: 10px;
    font-weight: 600;
    font-size: 13px;
  }

  .billing-link.ant-btn-link {
    padding: 0;
    height: auto;
    font-weight: 700;
    color: #f45b68;
  }

  .billing-tag {
    border-radius: 999px;
    font-weight: 700;
    background: #fff1f2;
    border-color: #fecdd3;
    color: #be123c;
  }

  .billing-amount {
    font-weight: 800;
    color: #111827;
  }

  .billing-period {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
  .billing-period__label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 700;
  }
  .billing-period__toggle {
    display: inline-flex;
    background: #f3f4f6;
    border-radius: 999px;
    padding: 3px;
    border: 1px solid #e5e7eb;
  }
  .billing-pill {
    border: 0;
    background: transparent;
    border-radius: 999px;
    padding: 6px 10px;
    font-size: 13px;
    font-weight: 800;
    color: #6b7280;
    cursor: pointer;
  }
  .billing-pill.is-active {
    background: #ffffff;
    color: #111827;
    box-shadow: 0 6px 14px rgba(17, 24, 39, 0.08);
  }

  .billing-plans-grid {
    // display: grid;
    // grid-template-columns: 1.05fr 1fr;
    // gap: 18px;
  }

  .billing-current {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    background: linear-gradient(180deg, #ffffff 0%, #fff7f8 100%);
    padding: 25px;
    box-shadow: 0 10px 24px rgba(17, 24, 39, 0.05);
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    min-height:550px;
  }

  .billing-current__badge {
    display: inline-flex;
    align-self: flex-start;
    padding: 6px 10px;
    border-radius: 999px;
    background: #ff4d4f2e;
    color: #374151;
    font-size: 13px;
    font-weight: 900;
  }
  .billing-current__name {
    margin-top: 10px;
    font-size: 18px;
    font-weight: 900;
    color: #111827;
  }
  .billing-current__price {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 900;
    color: #111827;
  }
  .billing-current__price span {
    font-weight: 700;
    color: #6b7280;
    margin-left: 4px;
    font-size: 13px;
  }
  .billing-current__desc {
    margin-top: 6px;
    font-size: 13px;
    color: #6b7280;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .billing-current__actions {
    margin-top: 12px;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .billing-hint {
    margin-top: 10px;
    font-size: 13px;
    color: #6b7280;
    line-height: 1.5;
  }

  .billing-available {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    background: #ffffff;
    padding: 14px 14px 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .billing-available__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }
  .billing-available__title {
    font-size: 15px;
    font-weight: 900;
    color: #111827;
  }
  .billing-available__nav {
    display: inline-flex;
    gap: 8px;
  }
  .billing-icon-btn.ant-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-color: #e5e7eb;
  }

  .billing-scroll {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(330px, 1fr);
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 10px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    align-items: stretch;
  }
  .billing-scroll::-webkit-scrollbar {
    height: 10px;
  }
  .billing-scroll::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 999px;
  }
  .billing-scroll::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 999px;
  }

  .billing-plan {
    scroll-snap-align: start;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 14px;
    background: #ffffff;
    box-shadow: 0 10px 18px rgba(17, 24, 39, 0.04);
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    height: 100%;
  }
  .billing-plan.is-highlighted {
    border-color: rgba(244, 91, 104, 0.35);
    box-shadow: 0 16px 28px rgba(244, 91, 104, 0.12);
  }
  .billing-plan__name {
    font-size: 15px;
    font-weight: 900;
    color: #ff4d4f;
  }
  .billing-plan__price {
    margin-top: 6px;
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex-wrap: wrap;
  }
  .billing-plan__priceValue {
    font-size: 20px;
    font-weight: 950;
    color: #111827;
  }
  .billing-plan__priceUnit {
    font-size: 13px;
    font-weight: 700;
    color: #6b7280;
  }
  .billing-plan__perks {
    margin: 10px 0 12px;
    padding: 0;
    list-style: none;
    display: grid;
    gap: 8px;
    color: #6b7280;
    font-size: 13px;
    font-weight: 600;
    align-content: start;
  }
  /* Only expand perks inside available-plan cards to push CTA to the bottom */
  .billing-plan .billing-plan__perks {
    flex: 1;
  }
  .billing-plan__perks li {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  .billing-check {
    width: 16px;
    height: 16px;
    border-radius: 999px;
    background: rgba(34, 197, 94, 0.14);
    border: 1px solid rgba(34, 197, 94, 0.3);
    position: relative;
    margin-top: 1px;
    flex: 0 0 16px;
  }
  .billing-check:after {
    content: "";
    position: absolute;
    inset: 4px 5px 5px 4px;
    border-right: 2px solid #16a34a;
    border-bottom: 2px solid #16a34a;
    transform: rotate(40deg);
  }
  .billing-plan__cta {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    margin-top: auto;
    flex-shrink: 0;
    height: 36px;
  }

  .billing-plan__cta--enterprise.ant-btn {
    border-color: #ff4d4f;
    color: #ff4d4f;
    font-weight: 700;
  }
  .billing-plan__cta--enterprise.ant-btn:hover {
    background: #f0f4f8;
    border-color: #1e3448;
    color: #1e3448;
  }

  .billing-plan__custom-pricing {
    font-size: 20px;
    font-weight: 950;
    letter-spacing: -0.02em;
  }

  /* ── Disabled plan overlay ─────────────────────────────────────── */
  .billing-plan__disabled-overlay {
    position: absolute;
    inset: 0;
    background: rgba(243, 244, 246, 0.82);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    border-radius: 14px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    opacity: 0;
    transition: opacity 0.22s ease;
  }
  .billing-plan:hover .billing-plan__disabled-overlay {
    opacity: 1;
  }
  .billing-plan__disabled-overlay-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .billing-plan__disabled-overlay-icon {
    font-size: 28px;
    color: #f45b68;
    line-height: 1;
  }
  .billing-plan__disabled-overlay-title {
    font-size: 13px;
    font-weight: 900;
    color: #111827;
    letter-spacing: -0.01em;
  }
  .billing-plan__disabled-overlay-text {
    font-size: 11.5px;
    font-weight: 500;
    color: #4b5563;
    line-height: 1.6;
    max-width: 220px;
  }

  /* ── Order limit badge ─────────────────────────────────────────── */
  .billing-plan__order-limit {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background: rgba(34, 197, 94, 0.08);
    border: 1px solid rgba(34, 197, 94, 0.25);
    border-radius: 10px;
    padding: 8px 10px;
    margin-bottom: 10px;
  }
  .billing-plan__order-limit.is-exceeded {
    background: rgba(244, 91, 104, 0.08);
    border-color: rgba(244, 91, 104, 0.3);
  }
  .billing-plan__order-limit-icon {
    font-size: 15px;
    color: #16a34a;
    margin-top: 1px;
    flex-shrink: 0;
    line-height: 1.4;
        height: 35px;
    /* border: 1px solid red; */
    width: 35px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 23px !important;
    background: #e5f0e9;
  }
  
  .billing-plan__order-limit-icon i{
    font-size:17px
  }

  .billing-plan__order-limit.is-exceeded .billing-plan__order-limit-icon {
    color: #f45b68;
        background: rgba(244, 91, 104, 0.12);
  }
  .billing-plan__order-limit-main {
    font-size: 13px;
    font-weight: 700;
    color: #111827;
  }
  .billing-plan__order-limit.is-exceeded .billing-plan__order-limit-main {
    color: #f45b68;
  }
  .billing-plan__order-limit-sub {
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
    margin-top: 2px;
  }
  .billing-plan__order-limit.is-exceeded .billing-plan__order-limit-sub {
    color: #f45b68;
  }

  /* ── Full-page loader before payment gateway opens ─────────────── */
  .billing-gateway-loader {
    position: fixed;
    inset: 0;
    background: rgba(17, 24, 39, 0.55);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .billing-gateway-loader__content {
    background: #ffffff;
    border-radius: 20px;
    padding: 44px 52px;
    box-shadow: 0 24px 60px rgba(17, 24, 39, 0.22);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    min-width: 280px;
    text-align: center;
  }
  .billing-gateway-loader__title {
    font-size: 15px;
    font-weight: 800;
    color: #111827;
  }
  .billing-gateway-loader__subtitle {
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
    line-height: 1.5;
  }

  .billing-payments-grid {
    display: grid;
    grid-template-columns: 1.4fr 0.9fr;
    gap: 14px;
  }

  .billing-payCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 14px;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    background: #ffffff;
  }
  .billing-payCard.is-default {
    background: linear-gradient(180deg, #ffffff 0%, #fff7f8 100%);
    border-color: rgba(244, 91, 104, 0.25);
  }
  .billing-payCard__left {
    display: flex;
    gap: 14px;
    min-width: 0;
    align-items: center;
  }
  .billing-payCard__brand {
    width: 56px;
    height: 38px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 900;
    background: #f3f4f6;
    color: #111827;
    flex: 0 0 56px;
    font-size: 13px;
  }
  .billing-payCard__meta {
    min-width: 0;
  }
  .billing-payCard__number {
    font-size: 13px;
    font-weight: 900;
    color: #111827;
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
  }
  .billing-defaultTag {
    display: inline-flex;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 900;
    background: #ecfdf5;
    border: 1px solid #bbf7d0;
    color: #166534;
  }
  .billing-payCard__name {
    margin-top: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 560px;
  }
  .billing-payCard__actions {
    display: inline-flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .billing-billingInfo {
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    background: linear-gradient(180deg, #ffffff 0%, #fff7f8 100%);
    padding: 14px;
    height: 100%;
  }
  .billing-billingInfo__title {
    font-size: 13px;
    font-weight: 900;
    color: #111827;
    margin-bottom: 10px;
  }
  .billing-billingInfo__row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px dashed #e5e7eb;
  }
  .billing-billingInfo__row:last-of-type {
    border-bottom: 0;
    margin-bottom: 10px;
  }
  .billing-billingInfo__label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 700;
  }
  .billing-billingInfo__value {
    font-size: 13px;
    color: #111827;
    font-weight: 900;
    text-align: right;
  }

  @media (max-width: 1200px) {
    .billing-plans-grid {
      grid-template-columns: 1fr;
    }
    .billing-payments-grid {
      grid-template-columns: 1fr;
    }
    .billing-header {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
